export const ERRORS = {
  email: "Email is not correct",
  password:
    "Upper-case, lower-case, numbers and special characters, at least 8 characters",
  repeat_password: "Your repeat password is not correct",
  required: "This field is required",
  word: "Word's length must be more than 3 characters"
};
